// extracted by mini-css-extract-plugin
export default {"game":"index_game_5kH2Q"};